// Typography utility for consistent text styling across the application
const typography = {
  heading1: 'text-4xl md:text-5xl lg:text-6xl font-bold leading-tight',
  heading2: 'text-3xl md:text-4xl lg:text-5xl font-bold leading-tight',
  heading3: 'text-2xl md:text-3xl lg:text-4xl font-bold leading-tight',
  heading4: 'text-xl md:text-2xl lg:text-3xl font-semibold leading-tight',
  subtitle: 'text-lg md:text-xl leading-relaxed',
  body: 'text-base md:text-lg leading-relaxed',
  small: 'text-sm md:text-base leading-relaxed',
  button: 'text-base md:text-lg font-medium',
  caption: 'text-sm md:text-base text-gray-600',
};

export default typography;
